import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { FormListSelectionOption, type FormListSelectionChangedArgs } from 'donor-elf-web/components/form/list-selection';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import ContactModel from 'donor-elf-web/models/contact';
import { inject as service } from '@ember/service';
import ContactsCache from 'donor-elf-web/services/contacts-cache';
import MergeContactsSection from 'donor-elf-web/components/add-something-modal/merge-contacts/section';
import FormUnderlineLabel from 'donor-elf-web/components/form/underline/label';
import FormListSelection from 'donor-elf-web/components/form/list-selection';

interface ComponentArgs {
  changeset: any;
  property: keyof ContactModel;
  propertyLabel: string;
  contactToKeep: ContactModel;
  contactToMerge: ContactModel;
}

export default class AddSomethingModalMergeContactsMergePropertyComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);
    this.populateListOptions();
    setTimeout(() => {
      this.updateChangesetGroups();
    });
  }

  @service contactsCache!: ContactsCache;

  @tracked listOptions: FormListSelectionOption[] = [];

  populateListOptions() {
    const { combinedGroups } = this;
    this.listOptions = sortByProperties(
      this.contactsCache.sortedGroups.map((x:string, index:number) => {
        return new FormListSelectionOption({ val: x, selected: combinedGroups.includes(x), index })
      }),
      ['selected:desc', 'index:asc']
    );
  }

  get combinedGroups() {
    return [
      ...(this.args.contactToKeep.groups || []),
      ...(this.args.contactToMerge.groups || [])
    ];
  }

  handleListSelectionsChanged = (selectionsChangedArgs: FormListSelectionChangedArgs) => {
    for (const option of this.listOptions) {
      option.selected = selectionsChangedArgs.selectedListOptions.includes(option);
    }
    this.updateChangesetGroups();
  }

  updateChangesetGroups() {
    this.args.changeset.set(
      'groups',
      this.listOptions.filter((x) => x.selected).map((x) => x.val)
    );
  }

  <template>
    <div ...attributes>
      <MergeContactsSection @header='Groups'>
        <div>
          <div class='row'>
            <div class='col'>
              <FormUnderlineLabel
                @label='Groups to Keep'
              >
                <FormListSelection
                  @listOptions={{this.listOptions}}
                  @listHeightClass='tw-max-h-56 tw-min-h-24 mb-1 tw-shadow'
                  class='mt-1'
                  @onSelectionsChanged={{this.handleListSelectionsChanged}}
                />
              </FormUnderlineLabel>
            </div>
            <div class='col'>
              <FormUnderlineLabel @label='Contact to Keep'>
                <div class='d-flex flex-wrap mt-1'>
                  {{#each @contactToKeep.sortedGroups as |group|}}
                    <div
                      class='mr-2 mb-2 px-2 tw-py-2px bg-brand-100 tw-rounded-xl tw-text-sm tw-leading-none'
                      role='button'
                    >
                      {{group}}
                    </div>
                  {{else}}
                    <div>---</div>
                  {{/each}}
                </div>
              </FormUnderlineLabel>
              <FormUnderlineLabel @label='Contact to Merge'>
                <div class='d-flex flex-wrap mt-1'>
                  {{#each @contactToMerge.sortedGroups as |group|}}
                    <div
                      class='mr-2 mb-2 px-2 tw-py-2px bg-brand-100 tw-rounded-xl tw-text-sm tw-leading-none'
                      role='button'
                    >
                      {{group}}
                    </div>
                  {{else}}
                    <div>---</div>
                  {{/each}}
                </div>
              </FormUnderlineLabel>
            </div>
          </div>
        </div>
      </MergeContactsSection>
    </div>
  </template>
}
